
import { Box, CircularProgress, Avatar, BoxProps } from "@mui/material"

import { CircularProgressStyle } from "../styles/CircularProgress"

export const CircularProgressIndicator = ( props: BoxProps ) => {

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', ...props }}>
                        
            <CircularProgress size={50} color='inherit' />
              
            <Box sx={ CircularProgressStyle } >
                
                <Avatar 
                    sx={{ width: 30, height: 30 }}
                    src={ process.env.PUBLIC_URL + '/favicon.png'}
                    alt='logo_saji'
                />
                
            </Box>
              
        </Box>
    )
}
